<div class="container-fluid tp-box" *ngIf="preauthEnabled" [@flipState]="flip" @grow>
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="card">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false)">
					<i class="material-icons">credit_card</i>
				</div>
				<h3 class="card-title">Pending Auths</h3>
			</div>
			<div class="card-body" *ngIf="viewing && viewing.length">
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th>Order</th>
								<th>Customer</th>
								<th class="text-right">Amount</th>
								<th>Auth Date</th>
								<th>Expires</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let a of viewing" [class.table-warning]="a.expiring_soon">
								<td>{{ a.orderno }}</td>
								<td>{{ a.customer_name || a.debtorno }}</td>
								<td class="text-right">{{ a.amount | number:'1.2-2' }}</td>
								<td>{{ a.created_iso }}</td>
								<td>
									<span *ngIf="a.days_until_expiry >= 0">{{ a.days_until_expiry }} day(s)</span>
									<span *ngIf="a.days_until_expiry < 0" class="text-danger">Expired</span>
								</td>
								<td>
									<span *ngIf="a.expiring_soon" class="badge badge-warning">Expiring soon</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="card-body" *ngIf="viewing && !viewing.length">
				<p class="text-muted mb-0">No uncaptured authorizations.</p>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(true)">
					<i class="material-icons">credit_card</i>
				</div>
				<p class="card-category">Pending Auths</p>
				<h3 class="card-title">
					<span *ngIf="!isLoading">{{ items.length }}</span>
					<span *ngIf="isLoading">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<small *ngIf="!isLoading && expiringSoonCount > 0">
				<p class="card-category text-warning text-right mt-2 mb-0">
					{{ expiringSoonCount }} expiring within 2 days
				</p>
			</small>
			<div class="card-footer">
				<div class="stats" [class.pointer]="!isLoading">
					<a *ngIf="!isLoading" (click)="toggleFlip(true)">
						<i class="material-icons">list</i>
						View list
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
